import { Injectable } from '@angular/core';
import { StorageConstants } from '../constant/storage.constant';
import { DeviceLocalStorageData } from '../models/rest/user/device-local-storage-data.model';
import { StringUtils } from '../utils/string.utils';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }
  getString(key: string, defValue?: string) {
    let value = localStorage.getItem(key);
    return StringUtils.isEmpty(value) ? defValue : value!;
  }
  setString(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  getNumber(key: string, defValue?: number) {
    let value = localStorage.getItem(key);
    return StringUtils.isEmpty(value) ? defValue : Number(value);
  }

  setNumber(key: string, value?: number) {
    if (value == null) {
      localStorage.removeItem(key);
    }
    else {
      localStorage.setItem(key, value.toString());
    }
  }


  getBoolean(key: string, defValue?: boolean) {
    let value = localStorage.getItem(key);
    if (StringUtils.isEmpty(value)) {
      return defValue ?? false;
    } else {
      return value!.toLowerCase() === 'true';
    }
  }

  setBoolean(key: string, value: boolean) {
    if (value == null) {
      localStorage.removeItem(key);
    }
    else {
      localStorage.setItem(key, value.toString());
    }
  }

  getJSONData(key: string) {
    let value = localStorage.getItem(key);

    return JSON.parse(value ?? "{}");
  }
  setJSONData(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getDeviceStorageData() {
    let data = this.getJSONData(StorageConstants.DEVICE_LOCAL_STORAGE);
    if (data == null) {
      data = new DeviceLocalStorageData();
      this.setJSONData(StorageConstants.DEVICE_LOCAL_STORAGE, data);

    }
    return data;
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }


}
